import { ChangeDetectionStrategy, Component, effect, input, InputSignal, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'se-side-details-note',
    templateUrl: './se-side-details-note.component.html',
    styleUrls: ['./se-side-details-note.component.scss'],
    standalone: true,
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeSideDetailsNoteComponent {
    title: InputSignal<string> = input<string>( 'DiagnosticQuery' );
    description: InputSignal<string> = input<string>('');

    sanitizedDescription = signal<string>(this.description());

    constructor() {
        effect(() => {
            const currentDescription = this.description();
            const htmlTagRegex = /<\/?[a-z][\s\S]*?>/gi;

            if (htmlTagRegex.test(currentDescription)) {
                // Rimuove i tag HTML e aggiorna la description
                const sanitized = currentDescription.replace(htmlTagRegex, '');
                this.sanitizedDescription.set(sanitized);
            } else {
                this.sanitizedDescription.set(currentDescription);
            }
        });
    }
}
